import { defineMessage } from 'services/localization';

export const messages = {
    cin7Name: defineMessage('cin'),
    titleCin7Name: defineMessage('cin_core'),
    connectToOrganisation: defineMessage('connect_your_cin_core_organisation'),
    connectToOrgHeader: defineMessage('perfect_for_a_quick_start_on_live_cin_data'),
    buttonConnectToOrg: defineMessage('connect_to_cin'),
};
